import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { LangProvider } from "@/lib/i18n";
import { AuthProvider } from "@/contexts/AuthContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import EmergencyBanner from "@/components/site/EmergencyBanner";
import FloatingCTA from "@/components/site/FloatingCTA";
import Home from "@/pages/Home";
import SchedulePage from "@/pages/SchedulePage";
import ContactPage from "@/pages/ContactPage";
import CityPage from "@/pages/CityPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ServiceAreas from "@/components/site/ServiceAreas";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) { el.scrollIntoView({ behavior: "smooth", block: "start" }); return; }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LangProvider>
         <SettingsProvider>
          <AuthProvider>
            <ScrollManager />
            <Toaster theme="dark" position="top-right" richColors />
            <EmergencyBanner />
            <Nav />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/schedule" element={<SchedulePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/areas" element={<main><ServiceAreas /></main>} />
              <Route path="/city/:city" element={<CityPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="*" element={<Home />} />
            </Routes>
            <Footer />
            <FloatingCTA />
          </AuthProvider>
         </SettingsProvider>
        </LangProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
